import SVG3DTagCloud from '3d-word-cloud';

const entries = [ { image: 'assets/img/skills/js.svg', width: '50', height: '50', tooltip: 'JavaScript', url: 'https://www.javascript.com/', target: '_top' },
    { image: 'assets/img/skills/es6.jpg', width: '50', height: '50', tooltip: 'ES6', url: 'http://es6-features.org/', target: '_top' },
    { image: 'assets/img/skills/react.svg', width: '80', height: '80', tooltip: 'React.js', url: 'https://reactjs.org/', target: '_top' },
    { image: 'assets/img/skills/Redux.png', width: '80', height: '80', tooltip: 'Redux', url: 'https://redux.js.org/', target: '_top' },
    { image: 'assets/img/skills/jquery.png', width: '80', height: '80', tooltip: 'Jquery', url: 'https://jquery.com/', target: '_top' },
    { image: 'assets/img/skills/sass.svg', width: '50', height: '50', tooltip: 'SASS', url: 'https://sass-lang.com/', target: '_top' },
    { image: 'assets/img/skills/twig.png', width: '50', height: '50', tooltip: 'Twig', url: 'https://twig.symfony.com/', target: '_top' },
    { image: 'assets/img/skills/pug.png', width: '50', height: '50', tooltip: 'Pug', url: 'https://pugjs.org', target: '_top' },
    { image: 'assets/img/skills/gulp.png', width: '80', height: '80', tooltip: 'Webpack', url: 'http://gulpjs.com/', target: '_top' },
    { image: 'assets/img/skills/github-logo.svg', width: '50', height: '50', tooltip: 'GitHub', url: 'https://github.com/', target: '_top' },
    { image: 'assets/img/skills/webpack.png', width: '80', height: '80', tooltip: 'Webpack', url: 'https://webpack.js.org/', target: '_top' },
];
const settings = {
    entries: entries,
    width: 480,
    height: 480,
    radius: '85%',
    radiusMin: 75,
    bgDraw: false,
    bgColor: '#fff',
    opacityOver: 1.00,
    opacityOut: 0.05,
    opacitySpeed: 6,
    fov: 800,
    speed: 0.5,
    fontFamily: 'Oswald, Arial, sans-serif',
    fontSize: '15',
    fontColor: '#000',
    fontWeight: 'normal',//bold
    fontStyle: 'normal',//italic 
    fontStretch: 'normal',//wider, narrower, ultra-condensed, extra-condensed, condensed, semi-condensed, semi-expanded, expanded, extra-expanded, ultra-expanded
    fontToUpperCase: true,
    tooltipFontFamily: 'Oswald, Arial, sans-serif',
    tooltipFontSize: '11',
    tooltipFontColor: '#fff',
    tooltipFontWeight: 'normal',//bold
    tooltipFontStyle: 'normal',//italic 
    tooltipFontStretch: 'normal',//wider, narrower, ultra-condensed, extra-condensed, condensed, semi-condensed, semi-expanded, expanded, extra-expanded, ultra-expanded
    tooltipFontToUpperCase: false,
    tooltipTextAnchor: 'left',
    tooltipDiffX: 0,
    tooltipDiffY: 10,
    animatingSpeed: 0.01,
    animatingRadiusLimit: 1.3
};

const tagcloud = ( function () { 
    var svg3DTagCloud = new SVG3DTagCloud( document.getElementById( 'tagcloud'  ), settings );
});

module.exports = tagcloud;



// WEBPACK FOOTER //
// ./app/blocks/skills/tagcloud.js